import AboutSlider from "@/Components/User/About/AboutSlider";
import Container from "@/Components/User/Common/Container";
import User from "@/Layouts/User";
import { useEffect, useState } from "react";
import MetaTags from "@/Components/SEO/MetaTags";
import AnimatedReveal from "@/Components/HOC/AnimatedReveal";
import { useLoading } from "@/context/loading";

export default function index({ aboutData }) {
  const [appLink, setAppLink] = useState("");
  useEffect(() => {
    setAppLink(getAppLink());
  }, []);

  const getAppLink = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      return "https://play.google.com/store/apps/details?id=com.qoncertapp.artist";
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "https://apps.apple.com/us/app/qoncert-live-shows/id1537042846";
    } else if (/Macintosh|Mac OS X/.test(userAgent)) {
      return "https://apps.apple.com/us/app/qoncert-live-shows/id1537042846";
    } else {
      return "https://www.qoncertapp.com/";
    }
  };

  // Use dynamic data from API, fallback to default if not available
  const servingArtistsData = aboutData?.servingArtists || {
    title: "Serving Artists",
    description: "Qoncert is your platform for growth. We provide a range of opportunities to perform, from intimate showcases to large-scale events, giving you the exposure you need to expand your fan base.\n\nOur mission is to empower you with tools and connections that open doors, helping you transition from dreaming about a music career to living it.",
    slider: [
      { image: "/assets/slider4.png" },
      { image: "/assets/slider3.png" },
      { image: "/assets/slider2.png" },
      { image: "/assets/slider1.png" }
    ]
  };

  const entertainingFansData = aboutData?.entertainingFans || {
    title: "Entertaining Fans",
    description: "We bring the best up-and-coming artists straight to you. Through Qoncert, you can discover new talent, support your favorite musicians, and experience unforgettable live performances.\n\nTogether, we're building a community where music thrives and fans play a vital role in shaping the future of the new music industry.",
    slider: [
      { image: "/assets/slider8.png" },
      { image: "/assets/slider7.png" },
      { image: "/assets/slider6.png" },
      { image: "/assets/slider5.png" }
    ]
  };

  const { isLoading } = useLoading();

  return (
    <div>
      <User>
        <MetaTags
          title="About Qoncert - Empowering Artists & Entertaining Fans"
          description="Qoncert is your platform for growth. We provide opportunities for artists to perform and connect with fans, while bringing the best up-and-coming artists to music lovers everywhere."
          keywords="music platform, artist opportunities, live performances, music community, artist growth, fan engagement, music industry"
        />
        <Container className="px-6 lg:px-0 ">
          <AnimatedReveal
            animation="bounce-in"
            className="mt-[34px] lg:mt-[133px] lg:px-[222px] "
            delay={isLoading ? 1.8 : 0.1}
          >
            <p className=" lg:text-center lg:text-[65px] lg:leading-[100px] text-[30px] leading-[32 px] lg:font-[700] tracking-wide font-[700]  ">
              {servingArtistsData.title}
            </p>
            <div className="mt-1 lg:mt-[83px] ">
              <div className="text-white lg:text-[#C7C7CC] lg:text-[24px] lg:font-[500] text-[14px] font-[500] leading-[22px] lg:leading-[36px] whitespace-pre-line">
                {servingArtistsData.description || ""}
              </div>
            </div>
          </AnimatedReveal>
          <AboutSlider data={servingArtistsData.slider || []} />
          <div className="mt-[41px] lg:mt-[61px] ">
            <p className=" mb-0 font-[700] lg:text-[65px] lg:leading-[100px] text-[30px] leading-[32px]  lg:text-center ">
              {entertainingFansData.title}
            </p>
            <div className="mt-3 lg:mt-[91px] lg:px-[220px] ">
              <div className="text-white lg:text-[#C7C7CC] lg:text-[24px] lg:font-[500] text-[14px] font-[500] leading-[22px] lg:leading-[36px] whitespace-pre-line">
                {entertainingFansData.description || ""}
              </div>
            </div>
          </div>
          <AboutSlider data={entertainingFansData.slider || []} />
          <div className="pt-[57px] lg:pb-[113px] flex items-center justify-center ">
            <button
              onClick={() => {
                window.open("https://play.qoncertapp.com/more-shows", "_blank");
              }}
              className="hidden lg:block px-[100px] py-[11px] text-[#010101] text-[30px] font-[700] leading-[42px] bg-[#FFFFFF] rounded-2xl "
            >
              Book a Show
            </button>
          </div>
        </Container>
      </User>
    </div>
  );
}

export async function getStaticProps() {
  const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL;

  try {
    const response = await fetch(`${BACKEND_URL}/webapi/manageAbout`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "getAboutData" }),
    });

    const aboutData = response.ok ? await response.json() : null;

    return {
      props: {
        aboutData: aboutData?.data || null,
      },
      revalidate: 180, // Revalidate every 3 minutes
    };
  } catch (error) {
    console.error("Error fetching about data:", error);
    return {
      props: {
        aboutData: null,
      },
      revalidate: 60, // Retry after 1 minute on error
    };
  }
}
